import { createTheme, type MantineThemeOverride } from "@mantine/core";

/** 输入类控件统一 sm，表格内按钮仍可显式 size=xs / compact-xs 覆盖 */
const inputSize = "sm" as const;

/**
 * Admin 全局主题：表单 / 弹层 / 卡片视觉一致。
 * 单点改默认，页面不必每个 TextInput 再写 size。
 */
export const adminTheme: MantineThemeOverride = createTheme({
  primaryColor: "blue",
  defaultRadius: "md",
  fontFamily: 'system-ui, -apple-system, "PingFang SC", "Microsoft YaHei", sans-serif',
  headings: {
    fontFamily: 'system-ui, -apple-system, "PingFang SC", "Microsoft YaHei", sans-serif',
    fontWeight: "600",
  },
  components: {
    TextInput: { defaultProps: { size: inputSize } },
    PasswordInput: { defaultProps: { size: inputSize } },
    NumberInput: { defaultProps: { size: inputSize } },
    Textarea: { defaultProps: { size: inputSize, minRows: 3 } },
    Select: { defaultProps: { size: inputSize } },
    MultiSelect: { defaultProps: { size: inputSize } },
    NativeSelect: { defaultProps: { size: inputSize } },
    FileInput: { defaultProps: { size: inputSize } },
    ColorInput: { defaultProps: { size: inputSize } },
    Autocomplete: { defaultProps: { size: inputSize } },
    JsonInput: { defaultProps: { size: inputSize } },
    Checkbox: { defaultProps: { size: inputSize } },
    Switch: { defaultProps: { size: inputSize } },
    Radio: { defaultProps: { size: inputSize } },
    SegmentedControl: { defaultProps: { size: inputSize, fullWidth: false } },
    Button: {
      defaultProps: {
        size: inputSize,
      },
    },
    ActionIcon: {
      defaultProps: {
        size: inputSize,
        variant: "subtle",
      },
    },
    Badge: {
      defaultProps: {
        size: "sm",
        variant: "light",
      },
    },
    Modal: {
      defaultProps: {
        centered: true,
        keepMounted: false,
        radius: "md",
        padding: "md",
        overlayProps: { backgroundOpacity: 0.45, blur: 2 },
      },
      styles: {
        title: {
          fontWeight: 600,
          fontSize: "var(--mantine-font-size-lg)",
        },
        body: {
          paddingTop: "var(--mantine-spacing-sm)",
        },
      },
    },
    Drawer: {
      defaultProps: {
        keepMounted: false,
        position: "right",
        size: "lg",
        padding: "md",
        overlayProps: { backgroundOpacity: 0.45, blur: 2 },
      },
      styles: {
        title: {
          fontWeight: 600,
          fontSize: "var(--mantine-font-size-lg)",
        },
      },
    },
    Fieldset: {
      defaultProps: {
        variant: "filled",
        radius: "md",
      },
      styles: {
        root: {
          padding: "var(--mantine-spacing-md)",
        },
        legend: {
          fontWeight: 600,
          fontSize: "var(--mantine-font-size-sm)",
          paddingInline: 6,
        },
      },
    },
    Card: {
      defaultProps: {
        shadow: "sm",
        padding: "lg",
        radius: "md",
        withBorder: true,
      },
    },
    Alert: {
      defaultProps: {
        variant: "light",
        radius: "md",
      },
    },
    Notification: {
      defaultProps: {
        withCloseButton: true,
      },
      styles: {
        root: {
          maxWidth: 420,
        },
        description: {
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          overflowWrap: "anywhere",
        },
      },
    },
    // 标签 / 描述 / 错误行距统一
    InputWrapper: {
      styles: {
        label: {
          marginBottom: 6,
          fontWeight: 500,
          fontSize: "var(--mantine-font-size-sm)",
        },
        description: {
          marginTop: 4,
          fontSize: "var(--mantine-font-size-xs)",
          lineHeight: 1.4,
        },
        error: {
          marginTop: 4,
          fontSize: "var(--mantine-font-size-xs)",
        },
      },
    },
  },
});
